import { useState } from 'react'
import menuOpcoes from '../../interfaces/propsMenuOpcoes'
import SubMenuOpcoes from '../SubMenuOpcoes'
import Permissoes from '../../middleware/Permissoes'
import '../../styles/menuopcoes.css'

function MenuRelatorio (props: menuOpcoes) {

    const [subMenu, setSubMenu] = useState(false)

    function exibirSubmenu () {
        setSubMenu (subMenu => !subMenu)
    }

    return (
        <Permissoes permissoes={['master', 'relatorio_acesso']}>
            <div>
                <div id='menuOpcoes' onClick={exibirSubmenu}>
                    {<img id='iconeMenu' src={props.icone} alt={props.alt}></img>}
                    <p id='tituloMenu'>{props.titulo}</p>
                </div>
                <div id='submenuOpcoes'>
                    <Permissoes permissoes={['master', 'relatorio_dre']}>
                        {subMenu && <SubMenuOpcoes redirect={'/dre'} texto='Demostração de Resultado' />}
                    </Permissoes>
                    <Permissoes permissoes={['master', 'relatorio_dfc']}>
                        {subMenu && <SubMenuOpcoes redirect={'/dfc'} texto='Demostração do Fluxo de Caixa' />}
                    </Permissoes>
                </div>
            </div>
        </Permissoes>
    )
}

export default MenuRelatorio